import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgToiletPaperDots = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7 11H7.01M12 11H12.01M9.5 11H9.51M15 10C15 13.3137 16.3431 16 18 16C19.6569 16 21 13.3137 21 10C21 6.68629 19.6569 4 18 4M15 10C15 6.68629 16.3431 4 18 4M15 10V14C15 15.8441 14.4749 18.7262 14 20H3C3.47493 18.7262 4 15.8441 4 14V10C4 6.68629 5.34315 4 7 4H18",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgToiletPaperDots;
